// biome-ignore lint/style/noRestrictedImports: this is basically only usage
import { useOidc, useOidcAccessToken } from '@axa-fr/react-oidc';

/**
 * Hook for all auth needs.
 * Better than using isAuthenticated from useOidc since it only checks for token existence.
 */
export const useAuth = () => {
  const { login, logout, renewTokens } = useOidc();
  const { accessToken: jwtToken, accessTokenPayload } = useOidcAccessToken() as TokenPayload;
  // check both existence of tokens and their expiration date
  // regular oidc only checks for existence of tokens :(
  const isAuthenticated = accessTokenPayload && new Date(accessTokenPayload?.exp * 1000) > new Date();
  return {
    isAuthenticated,
    login,
    logout,
    renewTokens,
    userInfo: accessTokenPayload,
    jwtToken: isAuthenticated ? jwtToken : null,
  };
};

type TokenPayload = {
  accessToken: string | null;
  accessTokenPayload: null | { sub: string; email?: string; exp: number };
};
